import { Route, Routes } from 'react-router-dom';
import { RequireAuth } from './auth/RequireAuth';
import { ContentProvider } from './data/ContentContext';
import { PortalLayout } from './layouts/PortalLayout';
import { LandingPage } from './pages/LandingPage';
import { OverviewPage } from './pages/OverviewPage';
import { InfoPage } from './pages/InfoPage';
import { DataIntelligencePage } from './pages/DataIntelligencePage';
import { AutomationPage } from './pages/AutomationPage';
import { SqmExpertPage } from './pages/SqmExpertPage';
import { SqmConsultantPage } from './pages/SqmConsultantPage';
import { XvtShipmentPage } from './pages/XvtShipmentPage';
import { ProcessControlPage } from './pages/ProcessControlPage';
import { ProcessControlSystemPage } from './pages/ProcessControlSystemPage';
import { ProcessControlToolPage } from './pages/ProcessControlToolPage';
import { RealTimeMonitoringPage } from './pages/RealTimeMonitoringPage';
import { SqmDataHubPage } from './pages/SqmDataHubPage';
import { ContributionsPage } from './pages/ContributionsPage';
import { NotFoundPage } from './pages/NotFoundPage';

export default function App() {
  return (
    <RequireAuth>
      <ContentProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/portal" element={<PortalLayout />}>
            <Route index element={<OverviewPage />} />
            <Route path="data-intelligence" element={<DataIntelligencePage />} />
            <Route path="automation" element={<AutomationPage />} />
            <Route path="sqm-expert" element={<SqmExpertPage />} />
            <Route path="sqm-consultant" element={<SqmConsultantPage />} />
            <Route
              path="sqm-consultant/xvt-shipment"
              element={<XvtShipmentPage />}
            />
            <Route
              path="sqm-consultant/xvt-build"
              element={<InfoPage slug="xvt-build" />}
            />
            <Route
              path="sqm-consultant/ok2-production-tool"
              element={<InfoPage slug="ok2-production-tool" />}
            />
            <Route
              path="sqm-consultant/safe-ramp"
              element={<InfoPage slug="safe-ramp" />}
            />
            <Route
              path="sqm-consultant/safe-transition"
              element={<InfoPage slug="safe-transition" />}
            />
            <Route
              path="sqm-consultant/spor-selection"
              element={<InfoPage slug="spor-selection" />}
            />
            <Route
              path="supplier-process-control"
              element={<ProcessControlPage />}
            />
            <Route
              path="supplier-process-control/system"
              element={<ProcessControlSystemPage />}
            />
            <Route
              path="supplier-process-control/system/cmt/real-time-monitoring"
              element={<RealTimeMonitoringPage />}
            />
            <Route
              path="supplier-process-control/system/:factory/:tool"
              element={<ProcessControlToolPage />}
            />
            <Route path="deep-research" element={<InfoPage slug="deep-research" />} />
            <Route path="sqm-data-hub" element={<SqmDataHubPage />} />
            <Route path="contributions" element={<ContributionsPage />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </ContentProvider>
    </RequireAuth>
  );
}
